import {
  AnyAction,
  CaseReducer,
  createAsyncThunk,
  createSlice
} from '@reduxjs/toolkit';
import ReduxSliceNames from 'src/constants/redux-slice-names';
import { getNotReadImeiCount } from 'src/services/customer/imei';

interface ICustomerImeiState {
  notReadCount: number;
}

export const fetchNotReadImeiCount = createAsyncThunk(
  ReduxSliceNames.CustomerImeiFetchNotReadCount,
  async () => {
    const { data } = await getNotReadImeiCount();
    return data.count;
  }
);

const initialState: ICustomerImeiState = {
  notReadCount: 0
};

const fetchNotReadImeiCountReducer: CaseReducer = (
  state: ICustomerImeiState,
  action: AnyAction
) => {
  state.notReadCount = action.payload;
};

const customerImeiSlice = createSlice({
  name: ReduxSliceNames.CustomerImei,
  initialState,
  reducers: {
    resetNotReadCountState(state: ICustomerImeiState) {
      state.notReadCount = 0;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchNotReadImeiCount.fulfilled,
      fetchNotReadImeiCountReducer
    );
  }
});

export const { resetNotReadCountState } = customerImeiSlice.actions;

export default customerImeiSlice;
